const styles = {
    container: {
        border: "solid 2px lightgray"
    }
}

export default styles;